import { userCloudApiFetch as apiFetch } from './userCloudApi';

const PLAYLIST_LOAD_TIMEOUT_MS = 15000;

let _playlists = [];
let _plListeners = new Set();
let _plLoaded = false;
let _plLoading = false;
let _plError = null;

function notifyPlListeners() {
  const snap = getPlaylistLoadState();
  _plListeners.forEach((fn) => fn(snap));
}

function withTimeout(promise, ms, message) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(message)), ms);
    Promise.resolve(promise).then(
      (value) => { clearTimeout(timer); resolve(value); },
      (err) => { clearTimeout(timer); reject(err); },
    );
  });
}

export function getPlaylistLoadState() {
  return {
    playlists: [..._playlists],
    loaded: _plLoaded,
    loading: _plLoading,
    error: _plError,
  };
}

export function resetUserPlaylistsForTests() {
  _playlists = [];
  _plLoaded = false;
  _plLoading = false;
  _plError = null;
}

export function subscribePlaylists(fn) {
  _plListeners.add(fn);
  return () => _plListeners.delete(fn);
}

export function prependPlaylist(playlist) {
  _playlists = [playlist, ..._playlists];
  notifyPlListeners();
}

export async function loadPlaylists() {
  _plLoading = true;
  _plError = null;
  notifyPlListeners();
  try {
    const data = await withTimeout(
      apiFetch('/api/user/playlists'),
      PLAYLIST_LOAD_TIMEOUT_MS,
      'Timed out loading playlists',
    );
    if (!data?.playlists) {
      _plError = 'Could not load playlists';
    } else {
      _playlists = data.playlists;
      _plError = null;
    }
  } catch (err) {
    _plError = err?.message || 'Could not load playlists';
  } finally {
    _plLoading = false;
    _plLoaded = true;
    notifyPlListeners();
  }
}

export function invalidateAndReloadPlaylists() {
  _plLoaded = false;
  return loadPlaylists();
}
